

export class FuelCalibrationStatusInput implements IFuelCalibrationStatusInput {
    /** The auto-generated id of the fuel calibration master */
    fuelCalibrationId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IFuelCalibrationStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fuelCalibrationId = _data["fuelCalibrationId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): FuelCalibrationStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new FuelCalibrationStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fuelCalibrationId"] = this.fuelCalibrationId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IFuelCalibrationStatusInput {
    /** The auto-generated id of the fuel calibration master */
    fuelCalibrationId: number;
    /** The updated status */
    status: number;
}

